import React, { useState } from 'react'

import { filter, get } from 'lodash'

import { Author, Organisation } from './dataStructures'

const AuthorItem = ({ name, orgKeys, isLast }: {name: string, orgKeys: number[], isLast: boolean}) => {
  const orgs = filter(orgKeys, x => !!x)
  return (
    <>
      {name}{orgs.length > 0 && <> <sup>{orgs.join(', ')}</sup></>}{!isLast && '; '}
    </>
  )
}

export const AuthorsList = ({ authors, organisations }: {authors: Author[], organisations?: Organisation[]}) => {
  const [expanded, setExpanded] = useState(false)

  const len = authors.length
  let displayAuthors: Author[] = []
  if (len <= 4 || expanded) {
    displayAuthors = authors.slice()
  } else {
    displayAuthors = authors.slice(0, 4)
    displayAuthors = displayAuthors.concat({ name: '...' })
  }

  return (
    <>
      {displayAuthors.map((x, i) =>
        <AuthorItem
          key={i}
          isLast={i === displayAuthors.length - 1}
          name={x.name}
          orgKeys={
            (x.organisations && organisations)
              ? x.organisations.map(y => {
                const filteredOrgs = organisations.filter(
                  (z) => {
                    return z.displayIndex === y + 1
                  }
                )
                return get(filteredOrgs[0], 'displayIndex') // Currently we only have 1 org to one author / contributor.
              })
              : []
          }
        />
      )}
      {len > 4 &&
        <button style={{ marginLeft: '10px' }} className='author-list-btn' onClick={() => setExpanded(!expanded)}>
          {expanded ? 'View Less' : 'View All'}
        </button>
      }
    </>
  )
}
